import { render, staticRenderFns } from "./FactoryBlock.vue?vue&type=template&id=01f3b210&scoped=true"
import script from "./FactoryBlock.vue?vue&type=script&lang=js"
export * from "./FactoryBlock.vue?vue&type=script&lang=js"
import style0 from "./FactoryBlock.vue?vue&type=style&index=0&id=01f3b210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f3b210",
  null
  
)

export default component.exports